import { jsx as _jsx } from "react/jsx-runtime";
import classNames from "classnames";
import { sanitize } from "isomorphic-dompurify";
import styles from "./RichText.module.scss";
export const RichText = ({ content, className, isDarkMode = false }) => (_jsx("div", { className: classNames(className, {
        [styles.darkMode]: isDarkMode,
    }), dangerouslySetInnerHTML: { __html: sanitize(content) } }));
//# sourceMappingURL=RichText.js.map